/* ═══════════════════════════════════════════════════════════════
   ICI SEARCH ENGINE v4 · 2026-10-12 — motor compartido del buscador
   Lo usan: snippets/ici-search.liquid (dropdown), assets/ici-and-search.js
   (formularios + página /search) y sections/main-search.liquid.
   1) Normaliza: acentos, mayúsculas, "sku 12603" / "código 14210" → código.
   2) Corrige ortografía contra el vocabulario REAL del catálogo
      (fonética salvadoreña: seseo s/c/z, yeísmo ll/y, b/v, h muda, ñ/n,
      x/s, gu/g + Damerau-Levenshtein).
   3) Expande regionalismos y sinónimos (assets/ici-search-dict.json).
   4) Arma la consulta Shopify SIN comodines ni AND explícito: medido el
      12-oct-2026, "taladro*" o "a AND b" inflan a 1,000 resultados con ruido;
      "a OR b" y "frase" entre comillas son precisos.
   5) Ordena (dropdown) por sustantivo principal y filtra ruido semántico.
   Rollback: quitar el <script> de este archivo en snippets/meta-tags.liquid;
   todo degrada a la búsqueda nativa sin errores.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.ICISearch) return;

  var DATA = window.ICISearchData || {};
  var D = null;          /* { syn: {clave: [canónicos]}, vocab: {palabra: frecuencia} } */
  var PH = null;         /* índice fonético: clave fonética -> [palabras] */
  var WORDS = null;      /* lista de palabras conocidas (vocab + claves de 1 palabra) */
  var loading = null;

  var STOP = {};
  ('de del la el los las un una unos unas para con y o u en por a al lo le su mi tu que sin ' +
   'quiero busco necesito venden tienen tiene hay precio precios barato barata baratos baratas comprar ' +
   'cuanto cuesta vale me un favor porfa porfavor').split(' ').forEach(function (w) { STOP[w] = 1; });

  function norm(s) {
    return String(s == null ? '' : s).toLowerCase().replace(/ñ/g, '\u0001')
      .normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\u0001/g, 'ñ')
      .replace(/[^a-z0-9ñ\/\.\-"\s]+/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function stem(w) {
    if (w.length > 4 && /ces$/.test(w)) return w.slice(0, -3) + 'z';
    if (w.length > 4 && /[lnrdj]es$/.test(w)) return w.slice(0, -2);
    if (w.length > 3 && /s$/.test(w)) return w.slice(0, -1);
    return w;
  }

  function words(s) {
    return norm(s).split(/[^a-z0-9ñ]+/).filter(Boolean);
  }

  /* Clave fonética del español salvadoreño */
  function phon(w) {
    var x = w.replace(/ch/g, '%').replace(/h/g, '');
    x = x.replace(/ll/g, 'y').replace(/ñ/g, 'n').replace(/v/g, 'b').replace(/w/g, 'gu')
      .replace(/gu(?=[ei])/g, 'G').replace(/g(?=[ei])/g, 'j').replace(/G/g, 'g')
      .replace(/qu(?=[ei])/g, 'k').replace(/c(?=[ei])/g, 's').replace(/z/g, 's')
      .replace(/c/g, 'k').replace(/x/g, 's').replace(/(.)\1+/g, '$1');
    return x.replace(/%/g, 'ch');
  }

  /* Distancia Damerau-Levenshtein (OSA) con corte temprano */
  function dist(a, b, max) {
    var la = a.length, lb = b.length;
    if (Math.abs(la - lb) > max) return max + 1;
    var d = [], i, j;
    for (i = 0; i <= la; i++) { d[i] = [i]; }
    for (j = 0; j <= lb; j++) { d[0][j] = j; }
    for (i = 1; i <= la; i++) {
      var rowMin = 99;
      for (j = 1; j <= lb; j++) {
        var c = a[i - 1] === b[j - 1] ? 0 : 1;
        var v = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + c);
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) v = Math.min(v, d[i - 2][j - 2] + 1);
        d[i][j] = v;
        if (v < rowMin) rowMin = v;
      }
      if (rowMin > max) return max + 1;
    }
    return d[la][lb];
  }

  function freq(w) {
    if (!D) return 0;
    return D.vocab[w] || (D.syn[w] ? 3 : 0);
  }

  function build(json) {
    D = { syn: json.syn || {}, vocab: json.vocab || {} };
    PH = {};
    WORDS = [];
    var add = function (w) {
      if (!w || w.length < 3 || /\d/.test(w)) return;
      WORDS.push(w);
      var k = phon(w);
      (PH[k] || (PH[k] = [])).push(w);
    };
    Object.keys(D.vocab).forEach(add);
    Object.keys(D.syn).forEach(function (k) { if (k.indexOf(' ') === -1 && !D.vocab[k]) add(k); });
  }

  function ready() {
    if (D) return Promise.resolve(true);
    if (loading) return loading;
    var url = DATA.dictUrl || (window.ICISearchData || {}).dictUrl;
    if (!url || !window.fetch) return Promise.resolve(false);
    loading = fetch(url, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { if (j) build(j); return !!D; })
      .catch(function () { loading = null; return false; });
    return loading;
  }

  function inCat(w) {
    return !!(D && (D.vocab[w] || D.vocab[stem(w)] || D.vocab[w + 's'] || D.vocab[w + 'es']));
  }

  function known(w) {
    if (!D) return true;
    return !!(inCat(w) || D.syn[w]);
  }

  function best(list) {
    var b = null, bf = -1;
    for (var i = 0; i < list.length; i++) {
      var f = freq(list[i]);
      if (f > bf) { bf = f; b = list[i]; }
    }
    return b;
  }

  /* Corrige una palabra desconocida. typingLast: el usuario aún escribe esta palabra.
     full=false: solo fonética (seseo, yeísmo, b/v, h, ñ, x, gu) — segura para enviar la búsqueda.
     full=true: además distancia de edición y completar palabra — solo cuando la búsqueda dio 0 resultados. */
  function correct(t, typingLast, full) {
    if (!D || t.length < 4 || /\d/.test(t) || known(t)) return null;
    var i, w;
    if (typingLast) {
      for (i = 0; i < WORDS.length; i++) { if (WORDS[i].indexOf(t) === 0) return null; }
    }
    var cands = PH[phon(t)] || PH[phon(stem(t))];
    if (cands && cands.length) return best(cands);
    /* Letras intercambiadas (talador→taladro, desarmadro→desarmador): mismas letras, distancia 1 */
    var srt = t.split('').sort().join(''), tr = [];
    for (i = 0; i < WORDS.length; i++) {
      w = WORDS[i];
      if (w.length === t.length && w.split('').sort().join('') === srt && dist(t, w, 1) <= 1) tr.push(w);
    }
    if (tr.length) return best(tr);
    if (!full) return null;
    var max = t.length <= 5 ? 1 : 2;
    var bw = null, bd = max + 1, bf = -1, p0 = phon(t).charAt(0);
    for (i = 0; i < WORDS.length; i++) {
      w = WORDS[i];
      if (Math.abs(w.length - t.length) > max) continue;
      if (phon(w).charAt(0) !== p0) continue;
      var d = dist(t, w, max);
      if (d > max) {
        var dp = dist(phon(t), phon(w), 1);
        if (dp <= 1 && t.length >= 6) d = max; else continue;
      }
      var f = freq(w);
      if (d < bd || (d === bd && f > bf)) { bd = d; bw = w; bf = f; }
    }
    if (bw) return bw;
    /* Palabra incompleta: completar con la más frecuente del catálogo */
    if (t.length >= 5 && !typingLast) {
      var pre = [];
      for (i = 0; i < WORDS.length; i++) { if (WORDS[i].indexOf(t) === 0) pre.push(WORDS[i]); }
      if (pre.length) return best(pre);
    }
    return null;
  }

  function fmt(alt) {
    if (alt.indexOf('+') > -1) return '(' + alt.split('+').join(' ') + ')';
    if (alt.indexOf(' ') > -1) return '"' + alt + '"';
    return alt;
  }

  var CODE_RX = /^[a-z]{0,6}-?\d{3,}[a-z0-9\-\/]*$/;

  /* Plan de búsqueda: qué se le pide a Shopify y con qué términos se ordena/filtra */
  function plan(raw, opts) {
    opts = opts || {};
    var r = { raw: String(raw == null ? '' : raw).trim(), q: '', changed: false, code: false, manual: false,
              terms: [], fixes: [], expands: [] };
    r.q = r.raw;
    var n = norm(r.raw);
    if (!n) return r;
    var mc = n.match(/^(?:sku|codigo|cod\.?|ref\.?|referencia|item|no\.?|num\.?|numero|#)\s*[:#\-]?\s*([a-z]{0,6}-?\d{3,}[a-z0-9\-\/]*)$/);
    if (mc) { r.code = true; r.q = mc[1].toUpperCase(); r.changed = r.q !== r.raw; return r; }
    /* Código de producto: una sola pieza ("14292", "esma-4590n") o prefijo corto + número ("tr 1234").
       "100 pies manguera" o "cable 100" NO son códigos. */
    var parts = n.split(' ');
    if ((parts.length === 1 && CODE_RX.test(n)) || (parts.length === 2 && parts[0].length <= 4 && /^\d{3,}/.test(parts[1]) && CODE_RX.test(parts.join('')))) { r.code = true; return r; }
    if (/["*()]|\s(and|or|not)\s/i.test(' ' + r.raw + ' ')) {
      r.manual = true;
      r.terms = words(n).filter(function (w) { return !STOP[w]; }).map(stem);
      return r;
    }
    var ws = n.split(' ');
    var groups = [], any = false, i = 0;
    while (i < ws.length) {
      var hit = false;
      if (D) {
        for (var len = Math.min(5, ws.length - i); len >= 2; len--) {
          var ph = ws.slice(i, i + len).join(' ');
          if (D.syn[ph]) { groups.push({ src: ph, alts: D.syn[ph].slice(), orig: false }); i += len; hit = true; any = true; break; }
        }
      }
      if (hit) continue;
      var w = ws[i], last = (i === ws.length - 1);
      i++;
      if (STOP[w] || (w.length < 2 && !/\d/.test(w))) continue;
      if (D && D.syn[w]) {
        groups.push({ src: w, alts: D.syn[w].slice(), orig: inCat(w) });
        any = true; continue;
      }
      if (!D || /\d/.test(w) || w.length < 4 || known(w)) { groups.push({ src: w, plain: true }); continue; }
      var c = correct(w, opts.typing && last, !!opts.full);
      if (c) {
        var alts = (D.syn[c] || [c]).slice();
        groups.push({ src: w, alts: alts, orig: false, fixed: c });
        r.fixes.push([w, c]); any = true; continue;
      }
      groups.push({ src: w, plain: true });
    }
    var terms = [];
    var pushT = function (s) {
      String(s).split(/[+ ]/).forEach(function (x) {
        x = norm(x); if (x && !STOP[x] && x.length > 1) { var st = stem(x); if (terms.indexOf(st) === -1) terms.push(st); }
      });
    };
    groups.forEach(function (g) {
      pushT(g.src);
      (g.alts || []).forEach(pushT);
      if (g.alts && !g.fixed) r.expands.push([g.src, g.alts]);
    });
    r.terms = terms;
    if (!any) return r;
    r.q = groups.map(function (g) {
      if (g.plain) return g.src;
      var alts = g.alts.slice();
      if (g.orig && alts.indexOf(g.src) === -1) alts.unshift(g.src);
      alts = alts.filter(function (v, k, a) { return a.indexOf(v) === k; }).slice(0, 6);
      return alts.length === 1 ? fmt(alts[0]) : '(' + alts.map(fmt).join(' OR ') + ')';
    }).join(' ');
    r.changed = r.q !== r.raw;
    return r;
  }

  function url(raw) {
    var p = plan(raw);
    /* options[unavailable_products]=show: medido 12-oct, con "agotados al final" el cemento Holcim (cotización, sin
       existencia online) quedaba detrás de 400 resultados y "cemento" mostraba pegamento PVC. El orden por
       disponibilidad lo hace el ranking v4 DENTRO de cada nivel de relevancia. */
    var u = '/search?q=' + encodeURIComponent(p.q) + '&type=product&options%5Bunavailable_products%5D=show';
    if (p.changed) u += '&oq=' + encodeURIComponent(p.raw) + '&ici_att=1';
    return u;
  }

  /* Nivel de relevancia de un producto (1 = el sustantivo principal es lo buscado) */
  var ACC_RX = /(repuesto|refaccion|refacciones)/;
  function tier(p, terms, qAcc) {
    var title = (p && p.title) || '';
    var w = words(title).map(stem);
    var g = 5;
    var has = function (x) { return terms.indexOf(x) > -1; };
    if (w.length && has(w[0])) g = 1;
    else if (w.slice(0, 3).some(has)) g = 2;
    else if (w.some(has)) g = 3;
    else if (words((p.product_type || p.type || '') + ' ' + (p.vendor || '')).map(stem).some(has)) g = 4;
    if (!qAcc && ACC_RX.test(norm(title))) g += 2;
    return g;
  }

  function rank(products, pl) {
    if (!products || products.length < 2 || !pl || !pl.terms || !pl.terms.length) return products || [];
    var qAcc = ACC_RX.test(norm(pl.raw));
    return products.map(function (p, i) {
      var av = (p.available === false) ? 1 : 0;
      return { p: p, k: tier(p, pl.terms, qAcc) * 10 + av, i: i };
    }).sort(function (a, b) { return a.k - b.k || a.i - b.i; }).map(function (x) { return x.p; });
  }

  /* Filtro de ruido: el producto debe contener lo buscado (o un sinónimo, o casi) en título/tipo/marca */
  function relevant(p, pl) {
    if (!pl || pl.code || !pl.terms || !pl.terms.length) return true;
    var hay = words((p.title || '') + ' ' + (p.product_type || p.type || '') + ' ' + (p.vendor || '')).map(stem);
    for (var i = 0; i < pl.terms.length; i++) {
      var t = pl.terms[i];
      for (var j = 0; j < hay.length; j++) {
        var h = hay[j];
        if (h === t || (t.length >= 3 && h.indexOf(t) === 0) || (t.length >= 5 && h.length >= 5 && h.charAt(0) === t.charAt(0) && dist(h, t, 1) <= 1)) return true;
      }
    }
    return false;
  }

  function filter(products, pl) {
    return (products || []).filter(function (p) { return relevant(p, pl); });
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  /* Texto para el aviso "mostrando resultados para…" */
  function describe(pl) {
    if (!pl) return '';
    if (pl.fixes.length) {
      return 'Mostrando resultados para <strong>' + esc(pl.fixes.map(function (f) { return f[1]; }).join(' ')) +
        '</strong> (escribiste «' + esc(pl.fixes.map(function (f) { return f[0]; }).join(' ')) + '»).';
    }
    if (pl.expands.length) {
      var e = pl.expands[0];
      var alts = e[1].map(function (a) { return a.replace(/\+/g, ' '); }).slice(0, 4).join(', ');
      return 'Resultados para <strong>«' + esc(pl.raw) + '»</strong> · incluimos: ' + esc(alts) + '.';
    }
    return '';
  }

  /* Analítica de comportamiento (Microsoft Clarity): búsqueda original del cliente */
  function track(raw, pl, count) {
    try {
      if (!window.clarity || !raw) return;
      window.clarity('set', 'ici_busqueda', String(raw).slice(0, 80));
      if (pl && pl.changed) window.clarity('set', 'ici_busqueda_motor', pl.fixes.length ? 'corregida' : 'sinonimo');
      if (typeof count === 'number' && count === 0) window.clarity('event', 'ici_busqueda_sin_resultados');
      else window.clarity('event', 'ici_busqueda');
    } catch (e) { }
  }

  /* Precarga del diccionario solo cuando el cliente va a buscar (no pesa en el resto del sitio) */
  function warm(e) {
    var t = e && e.target;
    if (!t || !t.closest) return;
    if (t.closest('input[name="q"], .ici-hdr-search-box, .ici-hdr-mob-search, #ici-mbar-search, [data-ici-search], .header__icon--search')) ready();
  }
  document.addEventListener('focusin', warm, true);
  document.addEventListener('input', warm, true);
  document.addEventListener('keydown', warm, true);
  document.addEventListener('pointerdown', warm, { capture: true, passive: true });
  if (location.pathname.indexOf('/search') === 0) ready();

  window.ICISearch = {
    version: '4.0.0',
    ready: ready,
    loaded: function () { return !!D; },
    plan: plan,
    url: url,
    rank: rank,
    filter: filter,
    relevant: relevant,
    describe: describe,
    track: track,
    norm: norm,
    stem: stem,
    correct: function (w, full) { return correct(norm(w), false, full !== false); }
  };
})();
